const findByLang = (lang: string, currentLangCode: string) => lang === currentLangCode;

export default findByLang;
